/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "service": {
            "nested": {
              "v1": {
                "nested": {
                  "DigitalWalletConfiguration": {
                    "fields": {
                      "cardToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "cardSuffix": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "nameOnCard": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "productDisplayName": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "paymentNetwork": {
                        "type": ".squareup.bbfrontend.service.v1.DigitalWalletConfiguration.PaymentNetwork",
                        "id": 5,
                        "rule": "optional"
                      },
                      "appleWalletPrimaryAccountIdentifier": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "PaymentNetwork": {
                        "values": {
                          "DO_NOT_USE_PAYMENT_NETWORK": 0,
                          "VISA": 1,
                          "MASTERCARD": 2,
                          "AMERICAN_EXPRESS": 3
                        }
                      }
                    }
                  },
                  "DigitalWalletProvisionApplePayRequest": {
                    "fields": {
                      "certificates": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "nonce": {
                        "type": "bytes",
                        "id": 2,
                        "rule": "optional"
                      },
                      "nonceSignature": {
                        "type": "bytes",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "DigitalWalletProvisionApplePayResponse": {
                    "fields": {
                      "encryptedPassData": {
                        "type": "bytes",
                        "id": 1,
                        "rule": "optional"
                      },
                      "activationData": {
                        "type": "bytes",
                        "id": 2,
                        "rule": "optional"
                      },
                      "ephemeralPublicKey": {
                        "type": "bytes",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DigitalWalletConfiguration && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DigitalWalletConfiguration?.nested?.PaymentNetwork && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DigitalWalletProvisionApplePayRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.DigitalWalletProvisionApplePayResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DigitalWalletConfiguration @ squareup/bbfrontend/common/workflow/screens/digital_wallet_configuration.proto at 12:1
 */
export const DigitalWalletConfiguration = $root.lookupType('squareup.bbfrontend.service.v1.DigitalWalletConfiguration');
fixType(DigitalWalletConfiguration, {
  cardToken: {
    notEmpty: true
  },
  cardSuffix: {
    notEmpty: true
  },
  nameOnCard: {
    notEmpty: true
  },
  productDisplayName: {
    notEmpty: true
  },
  paymentNetwork: {
    required: true
  }
});
Builder.createAndAttachToType(DigitalWalletConfiguration);
/**
 * SOURCE PaymentNetwork @ squareup/bbfrontend/common/workflow/screens/digital_wallet_configuration.proto at 35:3
 */
DigitalWalletConfiguration.PaymentNetwork = $root.lookupEnum('squareup.bbfrontend.service.v1.DigitalWalletConfiguration.PaymentNetwork').values;
/**
 * SOURCE DigitalWalletProvisionApplePayRequest @ squareup/bbfrontend/common/workflow/screens/digital_wallet_configuration.proto at 43:1
 */
export const DigitalWalletProvisionApplePayRequest = $root.lookupType('squareup.bbfrontend.service.v1.DigitalWalletProvisionApplePayRequest');
fixType(DigitalWalletProvisionApplePayRequest);
Builder.createAndAttachToType(DigitalWalletProvisionApplePayRequest);
/**
 * SOURCE DigitalWalletProvisionApplePayResponse @ squareup/bbfrontend/common/workflow/screens/digital_wallet_configuration.proto at 52:1
 */
export const DigitalWalletProvisionApplePayResponse = $root.lookupType('squareup.bbfrontend.service.v1.DigitalWalletProvisionApplePayResponse');
fixType(DigitalWalletProvisionApplePayResponse);
Builder.createAndAttachToType(DigitalWalletProvisionApplePayResponse);